<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineProps, defineEmits } from 'vue';
    import axios from 'axios';

    const props = defineProps({
        collectiviteId: { type: Number, required: true }
    });
    const emit = defineEmits(['completed']);

    const loading = ref(false);
    const errorMessage = ref('');
    const importFile = ref<File | null>(null);
    const importDatas = ref([] as Array<any>);
    const showImportSection = ref(false);

    async function downloadCsv() {
        try {
            const response = await axios.get("/backoffice/collectivites/membres/download_csv_template", { responseType: "blob" });
            const blob = new Blob([response.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "collectivite_membres_template.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Erreur de téléchargement :", error);
        }
    }

    async function onCsvImportFileLoaded(event: Event) {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            await doPrepareImportFile(file);
            input.value = '';
        }
    }

    async function doPrepareImportFile(csvFile: File) {
        try {
            loading.value = true;
            errorMessage.value = '';
            importFile.value = null;
            importDatas.value = [];

            const formToUpload = new FormData();
            formToUpload.append("import_file", csvFile);
            const response = await axios.post(`/backoffice/collectivites/membres/prepare_import_file`, formToUpload);
            // L'API retourne directement un array de rows
            importDatas.value = response.data || [];
            importFile.value = csvFile;
            showImportSection.value = true;

            if (importDatas.value.length === 0) {
                errorMessage.value = "Aucune donnée valide trouvée dans le fichier";
            }
        } catch (error: any) {
            errorMessage.value = error.response?.data?.message || error.message || "Erreur lors de la préparation du fichier";
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    async function doImportAction() {
        if (importDatas.value.length === 0) { return; }

        try {
            loading.value = true;
            errorMessage.value = '';
            // Extraire seulement les données (sans errors/has_errors)
            const dataToImport = importDatas.value.map((row: any) => row.data || row);
            await axios.post('/backoffice/collectivites/membres/import_file_datas', { 
                import_datas: dataToImport,
                collectivite_id: props.collectiviteId
            });
            
            // Reset
            importFile.value = null;
            importDatas.value = [];
            showImportSection.value = false;
            
            emit('completed');
        } catch(error: any) {
            errorMessage.value = error.response?.data?.message || error.message || "Erreur lors de l'importation";
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

    function cancelImport() {
        importFile.value = null;
        importDatas.value = [];
        showImportSection.value = false;
        errorMessage.value = '';
    }
</script>

<template>
    <div>
        <!-- Hidden file inputs (one for each view) -->
        <input id="file-upload-membres-details" name="file-upload" type="file" accept=".csv" @change="onCsvImportFileLoaded" class="display-none" />
        <input id="file-upload-membres-list" name="file-upload" type="file" accept=".csv" @change="onCsvImportFileLoaded" class="display-none" />
        
        <!-- Loading overlay -->
        <div style="display: flex; justify-content: center" v-if="loading">
            <div class="loader dark"></div>
        </div>

        <!-- Import section (shown after file is selected) -->
        <div v-if="showImportSection && importFile && !loading" class="widget px-6 py-7 mb-5">
            <div class="s14_mobile mb-4">
                <h3 class="secondary-font gap-4 mt-0 mb-2">
                    Fichier: {{ importFile.name }}
                </h3>
                <p class="mb-0">Nombre de membres à importer: <strong>{{ importDatas.length }}</strong></p>
            </div>

            <div v-if="errorMessage" class="text-red mb-4">{{ errorMessage }}</div>

            <div class="flex gap-3">
                <button type="button" @click="doImportAction" class="btn lg w-100" :disabled="loading">
                    <img src="/icons/icon-enregistrer.svg" class="btn-icon" alt="" />
                    <span>Importer {{ importDatas.length }} membre(s)</span>
                </button>
                <button type="button" @click="cancelImport" class="btn lg white2">
                    <span>Annuler</span>
                </button>
            </div>
        </div>
    </div>
</template>
